export enum InvestorsRoutes {
  CreateOne = 'create-one',
  Search = 'search',
  UpdateOne = 'update-one',

  // unique routes
  CreateUser = 'create-user', // for granting an investor login access
}
